var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-radio mr-2"},[_c('input',{attrs:{"type":"radio"},domProps:{"checked":_vm.isChecked,"value":_vm.value},on:{"change":_vm.handleChange}}),_c('span',{staticClass:"custom-radio__circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }